const nfInt = new Intl.NumberFormat("ko-KR", { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat("ko-KR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
export function formatInt(v) {
    if (v == null || !Number.isFinite(v))
        return "—";
    return nfInt.format(v);
}
export function formatNumber(v, digits = 1) {
    if (v == null || !Number.isFinite(v))
        return "—";
    return digits === 0 ? nfInt.format(v) : nf1.format(v);
}
export function formatPercent(v, digits = 1) {
    if (v == null || !Number.isFinite(v))
        return "—";
    return `${formatNumber(v, digits)}%`;
}
/** 처리량 + 단위. 설비(source)는 shots/min, 그 외 rows/min */
export function formatThroughput(v, nodeType) {
    if (v == null || !Number.isFinite(v))
        return "—";
    return `${formatNumber(v, v >= 100 ? 0 : 1)} ${throughputUnit(nodeType)}`;
}
export function throughputUnit(nodeType) {
    return nodeType === "source" ? "shots/min" : "rows/min";
}
/** 초 단위 latency → "12s" / "3분 4초" / "2시간 10분". 음수·비유한은 "—" */
export function formatDuration(seconds) {
    if (seconds == null || !Number.isFinite(seconds) || seconds < 0)
        return "—";
    if (seconds < 60)
        return `${Math.round(seconds)}s`;
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    if (m < 60)
        return s > 0 ? `${m}분 ${s}초` : `${m}분`;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    if (h < 24)
        return mm > 0 ? `${h}시간 ${mm}분` : `${h}시간`;
    const d = Math.floor(h / 24);
    return `${d}일 ${h % 24}시간`;
}
/** latency 표시: 1s 미만은 ms */
export function formatLatency(seconds) {
    if (seconds == null || !Number.isFinite(seconds) || seconds < 0)
        return "—";
    if (seconds < 1)
        return `${Math.round(seconds * 1000)}ms`;
    return formatDuration(seconds);
}
export function parseIso(iso) {
    if (!iso)
        return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d;
}
/** UTC ISO → 브라우저 로컬 시각 "HH:mm:ss" */
export function formatLocalTime(iso, withMs = false) {
    const d = parseIso(iso);
    if (!d)
        return "—";
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return withMs ? `${hh}:${mm}:${ss}.${String(d.getMilliseconds()).padStart(3, "0")}` : `${hh}:${mm}:${ss}`;
}
/** UTC ISO → 브라우저 로컬 "YYYY-MM-DD HH:mm:ss" */
export function formatLocalDateTime(iso) {
    const d = parseIso(iso);
    if (!d)
        return "—";
    const y = d.getFullYear();
    const mo = String(d.getMonth() + 1).padStart(2, "0");
    const da = String(d.getDate()).padStart(2, "0");
    return `${y}-${mo}-${da} ${formatLocalTime(iso)}`;
}
/** 툴팁용: "로컬 2026-08-29 17:40:00 (UTC+9) · UTC 2026-08-29T08:40:00Z" */
export function formatTimeTooltip(iso) {
    const d = parseIso(iso);
    if (!d)
        return "시각 없음";
    return `로컬 ${formatLocalDateTime(iso)} (${localTzLabel()}) · UTC ${d.toISOString()}`;
}
/** 브라우저 시간대 라벨 "UTC+9" */
export function localTzLabel() {
    const offMin = -new Date().getTimezoneOffset();
    const sign = offMin >= 0 ? "+" : "-";
    const abs = Math.abs(offMin);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `UTC${sign}${h}${m ? `:${String(m).padStart(2, "0")}` : ""}`;
}
/** "3초 전" / "5분 전" / "2시간 전" */
export function formatRelative(iso, nowMs = Date.now()) {
    const d = parseIso(iso);
    if (!d)
        return "—";
    const diff = Math.max(0, (nowMs - d.getTime()) / 1000);
    if (diff < 5)
        return "방금";
    return `${formatDuration(diff)} 전`;
}
export const STATUS_LABEL_KO = {
    healthy: "정상",
    running: "수집 중",
    warning: "경고",
    error: "오류",
    recovering: "복구 중",
    offline: "정지",
};
export const NODE_TYPE_LABEL_KO = {
    source: "설비",
    processor: "처리기",
    model: "모델",
    storage: "저장소",
    output: "출력",
};
/** CSS 변수 이름 (app/globals.css 의 --status-*) */
export function statusColorVar(status) {
    return `var(--status-${status})`;
}
